import styled from 'styled-components'

export const Container = styled.div<{ isExpanded: boolean }>`
  width: ${({ isExpanded }) => (isExpanded ? '228px' : '0px')};
  transition: all 1s;
  display: flex;
  flex-direction: column;
  position: sticky;
  top: 0px;
  padding-left: 24px;
  height: 100%;
  padding-right: ${({ isExpanded }) => (isExpanded ? '24px' : '0px')};
  padding-top: 70px;
  box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.25);
`

export const ToggleButton = styled.button<{ isExpanded: boolean }>`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  transition: transform 1s;
  transform: rotate(180deg);
  transform: ${({ isExpanded }) => isExpanded && 'none'};
  z-index: 99;
  position: absolute;
  display: flex;
  border: none;
  outline: none;
  align-items: center;
  justify-content: center;
  right: -12px;
  top: 74px;
  box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.4);
  cursor: pointer;
  .icon {
    max-width: 14px;
    max-height: 14px;
  }
`

export const Content = styled.div<{
  isExpanded: boolean
  isFinancePage: boolean
}>`
  opacity: ${({ isExpanded }) => (isExpanded ? 1 : 0)};
  transition: opacity 1s;
  gap: 24px;
  height: 100%;
  overflow: ${({ isExpanded }) => !isExpanded && 'hidden'};
  overflow: ${({ isFinancePage }) => !isFinancePage && 'hidden'};
`
